/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intervention_Plan_Subtitle_LevelInputs */



/**
* | output |
* | --- |
* | "Edit each floor" |
*
* @param {Intervention_Plan_Subtitle_LevelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const intervention_plan_subtitle_level = /** @type {((inputs?: Intervention_Plan_Subtitle_LevelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intervention_Plan_Subtitle_LevelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Edit each floor")
	return /** @type {LocalizedString} */ ("Éditer chaque niveau")
});